<script lang="ts">
    // import src from '../../../assets/warning_FILL0_wght400_GRAD0_opsz24.svg';
    import src from './svg/Icon Alert.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    scale = scale * 0.8; // fix scale
</script>

<div class="make-filter-black">
    <TemplateIcon {src} {scale} alt={title} hover={title} on:click />
</div>

<style>
    .make-filter-black {
        /* convert red svg icon to black */
        filter: hue-rotate(50deg) brightness(1.3);
    }
</style>
